import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logged-out-page',
  templateUrl: './logged-out-page.component.html',
  styleUrls: ['./logged-out-page.component.css']
})
export class LoggedOutPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
